// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

// Use production credentials for both development and production
const SUPABASE_URL = "https://nzkgsdntqmbknznbgnii.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im56a2dzZG50cW1ia256bmJnbmlpIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTI1MjcwOTQsImV4cCI6MjA2ODEwMzA5NH0.KJgOgjPSnm-J9ie4W2bJVVHkzmblgqkKmZHdYFAE8ck";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});